export type SketchPoint = { x: number; y: number };
export type SketchStroke = SketchPoint[];

const prefix = 'enactry-sketch-v1:';

export const loadSketch = (activityKey: string): SketchStroke[] => {
  try {
    const parsed = JSON.parse(
      localStorage.getItem(prefix + activityKey) || '[]',
    );
    if (!Array.isArray(parsed)) return [];
    return parsed
      .filter(Array.isArray)
      .slice(0, 200)
      .map((stroke) =>
        stroke
          .slice(0, 1000)
          .filter(
            (point): point is SketchPoint =>
              typeof point?.x === 'number' &&
              typeof point?.y === 'number' &&
              point.x >= 0 &&
              point.x <= 1 &&
              point.y >= 0 &&
              point.y <= 1,
          ),
      )
      .filter((stroke) => stroke.length > 0);
  } catch {
    return [];
  }
};

export const saveSketch = (
  activityKey: string,
  strokes: SketchStroke[],
): void => {
  try {
    localStorage.setItem(prefix + activityKey, JSON.stringify(strokes));
  } catch {
    // Drawing still works when storage is unavailable or full.
  }
};

export const clearStoredSketch = (activityKey: string): void => {
  try {
    localStorage.removeItem(prefix + activityKey);
  } catch {
    // Drawing still works when storage is unavailable.
  }
};
